import { AxiosPromise } from 'axios';
import { http } from 'services';
import config from 'config';

import * as Types from './types';

export const List = ({
  params,
  filter = {}
}: {
  params: Types.IParams;
  filter?: Record<string, any>;
}): AxiosPromise<{ data: { registers: Types.IApi.Certificate.Response[] } }> => {
  return http.request.get<{ data: { registers: Types.IApi.Certificate.Response[] } }>(`/register/list`, {
    params: {
      ...filter,
      page: params.page - 1,
      size: params.limit,
      sort: 'id,desc'
    }
  });
};

export const Single = ({
  id
}: Types.IApi.Certificate.Request): AxiosPromise<{ data: Types.IApi.Certificate.Response }> => {
  return http.request.get<{ data: Types.IApi.Certificate.Response }>(`/register/view?id=${id}`);
};

export const Report = ({
  params
}: {
  params: Types.IReportParams;
}): AxiosPromise<{ data: { content: Types.IApi.Report[] } }> => {
  return http.request.get<{ data: { content: Types.IApi.Report[] } }>(
    `/register/register-report-public/list-by-register-id/${params.registerId}`,
    {
      params: {
        page: params.page - 1,
        size: params.limit,
        sort: 'id,desc'
      }
    }
  );
};

export const SendReport = ({ values }: { values: Types.IForm.SendReport }): AxiosPromise<any> => {
  return http.request.post<any>(`/process/register-report`, {
    register_id: Number(values.registerId),
    text: values.text,
    report_file_id: Number(values.reportFileId)
  });
};

export const ChangeActualPhone = ({ values }: { values: Types.IForm.ChangeActualPhone }): AxiosPromise<any> => {
  return http.request.post<any>(
    `/process/change-actual-phone`,
    {},
    {
      baseURL: config.api.base_url_v2,
      params: {
        register_id: Number(values.registerId),
        phone: '998' + values.phone
      }
    }
  );
};

export const ReportHistory = ({ params }: { params: Types.IReportParams }): AxiosPromise<any> => {
  return http.request.get<any>(`/register/register-report/list-by-register-id/${params.registerId}`, {
    params: {
      page: params.page - 1,
      size: params.limit,
      sort: 'id,desc'
    }
  });
};
